export const getIsBelowScrollThreshold = state => state.app.isBelowScrollThreshold

export const getIsOffHomePage = state => state.app.isOffHomePage
